import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function fetchSearchFitlerReducer(state = initialState.searchFilters, action) {
  switch (action.type) {
    case types.SET_FILTER_LIST_SUCCESS: {
      return Object.assign({}, state, {
        filters: action.filters,
      });
    }
    case types.SET_SEARCH_TYPE_ID: {
      return Object.assign({}, state, {
        searchTypeId: action.searchTypeId,
      });
    }
    default:
      return state;
  }
}
